import axios from "axios";
import db from "../../database";
import store from "../index";

var _source = undefined;
var bulk_source = undefined;

const state = {
  group_view: false,
  groups: {
    group_list: [],
    group_count: 0,
  },
  cart: {},
  isGvSale: false,
};

const mutations = {
  setGroupView(state, data) {
    state.group_view = data;
  },
  saveVoucherGroups(state, data) {
    state.groups.group_list = data.groupList;
    state.groups.group_count = data.groupCount;
  },
  clearVoucherGroups(state) {
    state.groups.group_list = [];
    state.groups.group_count = 0;
  },
  cartData(state, data) {
    state.cart = data;
  },
  setGvSale(state, data) {
    state.isGvSale = data;
  },
  clearCart(state) {
    state.cart = {
      cart_details: [],
      group_cart_details: [],
      subtotal: 0,
      total_amount: 0,
      total_group: 0,
      total_item_in_cart: 0,
      total_tax: 0,
    };
  },
};

const actions = {
  getVoucherGroup({ commit, rootGetters }, filter) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        { url: "/gv/getGvGroupList" },
        rootGetters["sessions/getCustomerParam"]
      );

      if (filter.length > 0) data.filter_by = filter;

      axios
        .post(data.url, data)
        .then((res) => {
          commit("saveVoucherGroups", res.data.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getVoucherGroupData({ rootGetters }, group_id) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        { url: "/gv/getGroupDetails", gv_group_id: group_id },
        rootGetters["sessions/getCustomerParam"]
      );

      axios
        .post(data.url, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  getVoucherList({ rootGetters }, get) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          url: "/gv/getVoucherList",
          gv_group_id: get.gv_group_id,
          page: get.page,
          per_page: get.per_page,
        },
        rootGetters["sessions/getCustomerParam"]
      );

      axios
        .get(data.url, { params: data })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  cartActions({ rootGetters, dispatch }, gvData) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          url: "/gv/cart-update",
          gv_list: JSON.stringify(gvData.selected),
          gv_group_id: gvData.gv_group_id,
          action_type: gvData.action_type,
        },
        rootGetters["sessions/getCustomerParam"]
      );

      if (
        gvData.action_type == "bulk_add" ||
        gvData.action_type == "group_qty_update"
      ) {
        data.bulk_qty = gvData.bulk_qty;
        // if (gvData.value_type == "Custom") {
        data.value_type = gvData.value_type;
        data.gift_value = gvData.gift_value;
        data.sale_value = gvData.sale_value;
        // }
      }

      if (gvData.action_type == "sale_value_update") {
        data.gift_value = gvData.gift_value;
        data.gv_id = gvData.gv_id;
        data.voucher_code = gvData.voucher_code;
      }

      if (typeof _source != typeof undefined) {
        _source.cancel("Operation canceled due to new request.");
      }

      _source = axios.CancelToken.source();

      axios
        .post(data.url, data, { cancelToken: _source.token })
        .then((res) => {
          if (res.data.status != "fail")
            dispatch("cartDetails").then((res) => {
              resolve(res);
            });
          else resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  cartDetails({ rootGetters, commit, dispatch }) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        { url: "/gv/cart-details" },
        rootGetters["sessions/getCustomerParam"]
      );
      axios
        .post(data.url, data)
        .then((res) => {
          db.gvList.clear();
          commit("cartData", res.data.data);
          if (res.data.data.cart_details.length > 0)
            dispatch("mapVoucherToDatabase");
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  mapVoucherToDatabase({ state }) {
    db.gvList.clear();
    state.cart.cart_details.forEach((item) => {
      db.gvList.add({
        is_received_boolean: true,
        gv_id: item.gv_id,
        gv_group_id: item.gv_group_id,
        sale_value: item.sale_value,
        gift_value: item.gift_value,
        voucher_sequence: item.voucher_sequence,
        gv_code: item.voucher_code,
      });
    });
  },

  checkout({ state, rootGetters, rootState }) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          url: "/gv/process-to-checkout",
          subtotal: state.cart.subtotal,
          total_tax: state.cart.total_tax,
          total_amount: state.cart.total_amount,
          total_item_in_cart: state.cart.total_item_in_cart,
          cust_gstin: rootState.billing.billing.customer.data.hasOwnProperty(
            "gstin"
          )
            ? this.state.billing.billing.customer.data.gstin
            : "",
        },
        rootGetters["sessions/getCustomerParam"]
      );

      axios
        .post(data.url, data)
        .then((res) => {
          store.commit("billing/saveOrder", res.data);
          store.commit(
            "billing/getTotalPayable",
            res.data.order_summary.total_payable
          );
          let cust_info = res.data.customer_info;
          cust_info.customer_bal =
            cust_info.customer_bal == null ? "0.00" : cust_info.customer_bal;
          store.commit("billing/getOnAccountData", cust_info);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getSaleValue({ rootGetters }, gvData) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          url: "/gv/cal-gift-value",
          gv_group_id: gvData.gv_group_id,
          gift_value: gvData.gift_value,
          action_type: gvData.action_type,
        },
        rootGetters["sessions/getCustomerParam"]
      );

      if (typeof bulk_source != typeof undefined) {
        bulk_source.cancel("Operation canceled due to new request.");
      }

      bulk_source = axios.CancelToken.source();

      axios
        .post(data.url, data, { cancelToken: bulk_source.token })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  tagCustomerToGv({ rootGetters, dispatch }, gvData) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          url: "/gv/add-user",
          action_type: gvData.action_type,
          customer_mobile: gvData.customer_mobile,
          gv_group_id: gvData.gv_group_id,
        },
        rootGetters["sessions/getCustomerParam"]
      );

      if (
        gvData.action_type == "tag_individual" ||
        gvData.action_type == "remove_individual"
      )
        data.gv_id = gvData.gv_id;

      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status != "fail")
            dispatch("cartDetails").then((res) => {
              resolve(res);
            });
          else resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  getRange({ rootGetters }, gvData) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          url: "/gv/getRangeList",
          gv_group_id: gvData.gv_group_id,
        },
        rootGetters["sessions/getCustomerParam"]
      );

      axios
        .post(data.url, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  gvListRedeemption({ rootGetters, rootState }, gvData) {
    return new Promise((resolve, reject) => {
      let data = Object.assign(
        {
          url: "/gv-list-for-redeem",
          action_type: gvData.type,
          order_id: rootState.billing.billing.order.data.order_id,
          redeem_by: gvData.by,
        },
        rootGetters["sessions/getCustomerParam"]
      );

      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "success") resolve(res.data.data);
          else reject(res);
        })
        .catch((err) => reject(err));
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
